import { Image } from "expo-image";
import {
  Dimensions,
  Modal,
  PixelRatio,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import MoneyIcon from "../../icons/MoneyIcon";
import FowardFlatArrow from "../../icons/FowardFlatArrow";
import Colours from "../../utils/Colours";
import { useState } from "react";
import TopHeaderComponent from "../aTopHeader/TopHeaderComponent";
import TablesForBidding from "./TablesForBidding";
import { useNavigation, useRoute } from "@react-navigation/native";
import { SafeAreaView } from "react-native-safe-area-context";
import { FontAwesome6, MaterialCommunityIcons } from "@expo/vector-icons";
import { getPairedPrinters } from "../../services/printerService";

const { width, height } = Dimensions.get("window");
const dpr = Math.round(PixelRatio.get() || 1);
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;
const VAL_NAME = "dxfdmlk0f";
const MAX_RETRIEZ = 20;

// Function to adjust font size
const dynamicFontSize = (size) => {
  const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
  const newSize = size * scaleFactor;

  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const ManageBrandActivities = () => {
  const [isBlockedAccess, setIsBlockedAccess] = useState(false);
  const [ongoingBids, setShowOngoingBids] = useState(false);
  const [showTableForBidding, setShowTableForBidding] = useState(false);

  const navigation = useNavigation();
  const route = useRoute();

  const { selectedBrandData } = route.params;

  console.log("selectedBrandData", selectedBrandData);

  // const handleCreateTable = () => {
  //   // setShowTableForBidding(true);
  //   // navigation.navigate("biddingTables", selectedBrandData);
  //   navigation.navigate("tableOrShow", { selectedBrandData });
  // };
  // const handleManageTableBids = () => {
  //   //setShowOngoingBids(true);
  //   navigation.navigate("manageTableBids", { selectedBrandData });
  // };

  // const handleShowOngoingBids = () => {
  //   //setShowOngoingBids(true);
  //   navigation.navigate("tableBidManage", { selectedBrandData });
  // };

  const handleImageError = () => {};

  // const handleShowQRCode = () => {
  //   navigation.navigate("showQRCode", { selectedBrandData });
  // };

  // // Modern Classic Action Menu Array mapping out clean view components
  // const menuOptions = [
  //   {
  //     title: "Manage Orders",
  //     icon: (
  //       <MaterialCommunityIcons
  //         name="clipboard-text-outline"
  //         size={dynamicSize(22)}
  //         color={Colours.PRIMARY}
  //       />
  //     ),
  //     onPress: () => navigation.navigate("manageOrders", { selectedBrandData }),
  //   },
  //   {
  //     title: "Menu Management",
  //     icon: (
  //       <MaterialCommunityIcons
  //         name="silverware-fork-knife"
  //         size={dynamicSize(22)}
  //         color={Colours.PRIMARY}
  //       />
  //     ),
  //     onPress: () => navigation.navigate("menuManagementScreen", { selectedBrandData }),
  //   },
  //   // {
  //   //   title: "Set minimum spend",
  //   //   icon: <MoneyIcon height={dynamicSize(22)} width={dynamicSize(22)} color={Colours.PRIMARY} />,
  //   //   onPress: () => navigation.navigate("minspend", { selectedBrandData }),
  //   // },
  //   // {
  //   //   title: "Manage Transactions",
  //   //   icon: (
  //   //     <MaterialCommunityIcons
  //   //       name="text-box-check-outline"
  //   //       size={dynamicSize(22)}
  //   //       color={Colours.PRIMARY}
  //   //     />
  //   //   ),
  //   //   onPress: () => navigation.navigate("manageWalkInAccess", { selectedBrandData }),
  //   // },
  //   {
  //     title: "Manage Waiters",
  //     icon: (
  //       <MaterialCommunityIcons
  //         name="account-tie-outline"
  //         size={dynamicSize(22)}
  //         color={Colours.PRIMARY}
  //       />
  //     ),
  //     onPress: () => navigation.navigate("manageWaiters", { selectedBrandData }),
  //   },
  //   {
  //     title: "Wallet and Transfers",
  //     icon: (
  //       <MaterialCommunityIcons
  //         name="wallet-outline"
  //         size={dynamicSize(22)}
  //         color={Colours.PRIMARY}
  //       />
  //     ),
  //     onPress: () => {
  //       navigation.navigate("walletAndTransfers", { selectedBrandData });
  //     },
  //   },
  //   {
  //     title: "Transfer history",
  //     icon: (
  //       <MaterialCommunityIcons name="history" size={dynamicSize(22)} color={Colours.PRIMARY} />
  //     ),
  //     onPress: () => {
  //       navigation.navigate("transferHistoryList", { selectedBrandData });
  //     },
  //   },
  //   {
  //     title: "Printer Setup",
  //     icon: (
  //       <MaterialCommunityIcons name="history" size={dynamicSize(22)} color={Colours.PRIMARY} />
  //     ),
  //     onPress: () => navigation.navigate("printerScreen", { selectedBrandData }),
  //   },
  // ];

  const menuOptions = [
    {
      title: "Manage Orders",
      allowedFor: ["Nightlife Venue"],
      icon: (
        <MaterialCommunityIcons
          name="clipboard-text-outline"
          size={dynamicSize(22)}
          color={Colours.PRIMARY}
        />
      ),
      onPress: () => navigation.navigate("manageOrders", { brandId: selectedBrandData._id }),
    },

    {
      title: "Create Show",
      allowedFor: ["Promoter"],
      icon: (
        <MaterialCommunityIcons
          name="party-popper"
          size={dynamicSize(22)}
          color={Colours.PRIMARY}
        />
      ),
      onPress: () => navigation.navigate("createShow", { selectedBrandData }),
    },

    {
      title: "Manage Shows",
      allowedFor: ["Nightlife Venue", "Promoter"],
      icon: (
        <MaterialCommunityIcons
          name="calendar-star"
          size={dynamicSize(22)}
          color={Colours.PRIMARY}
        />
      ),
      onPress: () =>
        navigation.navigate("promoterShowListScreen", { selectedBrandData, origin: "analytics" }),
    },

    {
      title: "Menu Management",
      allowedFor: ["Nightlife Venue", "Promoter"],
      icon: (
        <MaterialCommunityIcons
          name="silverware-fork-knife"
          size={dynamicSize(22)}
          color={Colours.PRIMARY}
        />
      ),
      onPress: () => {
        const isPromoter = selectedBrandData?.category?.toLowerCase() === "promoter";

        if (isPromoter) {
          // Promoters pick a show first
          navigation.navigate("promoterShowListScreen", {
            selectedBrandData,
            origin: "menuManagement",
          });
        } else {
          // Venues manage their default menu directly
          navigation.navigate("menuManagementScreen", { selectedBrandData });
        }
      },
    },

    {
      title: "Manage Waiters",
      allowedFor: ["Nightlife Venue"],
      icon: (
        <MaterialCommunityIcons
          name="account-tie-outline"
          size={dynamicSize(22)}
          color={Colours.PRIMARY}
        />
      ),
      onPress: () => navigation.navigate("manageWaiters", { selectedBrandData }),
    },

    {
      title: "Wallet and Transfers",
      allowedFor: ["Nightlife Venue", "Promoter"],
      icon: (
        <MaterialCommunityIcons
          name="wallet-outline"
          size={dynamicSize(22)}
          color={Colours.PRIMARY}
        />
      ),
      onPress: () => navigation.navigate("walletAndTransfers", { selectedBrandData }),
    },

    {
      title: "Transfer History",
      allowedFor: ["Nightlife Venue", "Promoter"],
      icon: (
        <MaterialCommunityIcons name="history" size={dynamicSize(22)} color={Colours.PRIMARY} />
      ),
      onPress: () => navigation.navigate("transferHistoryList", { selectedBrandData }),
    },

    {
      title: "Printer Setup",
      allowedFor: ["Nightlife Venue"],
      icon: (
        <MaterialCommunityIcons
          name="printer-outline"
          size={dynamicSize(22)}
          color={Colours.PRIMARY}
        />
      ),
      onPress: () => navigation.navigate("printerScreen", { selectedBrandData }),
    },
  ];
  const filteredMenuOptions = menuOptions.filter((option) =>
    option.allowedFor.includes(selectedBrandData?.category),
  );
  return (
    <SafeAreaView style={styles.safeArea}>
      <TopHeaderComponent headerText={"Manage Brand"} hideScreen={() => navigation.goBack()} />

      <ScrollView
        style={styles.componentStyle}
        contentContainerStyle={styles.scrollContent}
        showsVerticalScrollIndicator={false}
      >
        {/* Modern Horizontal Brand Banner Context Profile */}
        <View style={styles.brandHeroCard}>
          <Image
            source={{ uri: selectedBrandData?.image || "https://placehold.co/150" }}
            style={styles.brandImage}
            contentFit="cover"
            cachePolicy="disk"
            onError={handleImageError}
          />
          <View style={styles.brandMetaInfo}>
            <Text style={styles.nameTxt} numberOfLines={1}>
              {selectedBrandData?.brandName || "Company Title"}
            </Text>
            <Text style={styles.emailTxt} numberOfLines={2}>
              {selectedBrandData?.brandAddress || "Location Details Not Set"}
            </Text>
          </View>
        </View>

        <Text style={styles.sectionHeading}>Management Console</Text>

        {/* Clean Menu Action Map Stack Loop */}
        <View style={styles.menuWrapper}>
          {/* {menuOptions.map((option, index) => ( */}
          {filteredMenuOptions.map((option, index) => (
            <TouchableOpacity
              key={index}
              style={[styles.profileDataContainer, isBlockedAccess && styles.disabledContainer]}
              onPress={option.onPress}
              disabled={isBlockedAccess}
              activeOpacity={0.7}
            >
              <View style={styles.profileDataSubContainer}>
                <View style={styles.iconCircleWrapper}>{option.icon}</View>
                <View style={styles.flatArrowContainer}>
                  <Text style={styles.textTxt}>{option.title}</Text>
                  <FowardFlatArrow color={Colours.PRIMARY} />
                </View>
              </View>
            </TouchableOpacity>
          ))}
        </View>
      </ScrollView>
    </SafeAreaView>
  );
};

export default ManageBrandActivities;

const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
    backgroundColor: "white",
  },
  componentStyle: {
    backgroundColor: Colours.LIGHTEST,
    flex: 1,
  },
  scrollContent: {
    flexGrow: 1,
    padding: dynamicSpacing(20),
    paddingBottom: 100,
  },
  // Modern Horizontal Profile Presentation Header Card
  brandHeroCard: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "white",
    padding: dynamicSpacing(20),
    borderRadius: dynamicSize(16),
    marginBottom: dynamicSpacing(25),
    elevation: 2,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.08,
    shadowRadius: 4,
  },
  brandImage: {
    width: dynamicSize(70),
    height: dynamicSize(70),
    borderRadius: dynamicSize(14), // Modern soft-rounded corners instead of circles
    backgroundColor: "#F5F5F7",
  },
  brandMetaInfo: {
    flex: 1,
    marginLeft: dynamicSpacing(15),
    justifyContent: "center",
  },
  nameTxt: {
    color: Colours.DARKGRAY,
    fontSize: dynamicFontSize(18),
    fontFamily: "Sen-Bold",
    marginBottom: dynamicSpacing(4),
  },
  emailTxt: {
    color: Colours.DARKLIGHTGRAY,
    fontSize: dynamicFontSize(13),
    fontFamily: "Sen-Regular",
    lineHeight: dynamicFontSize(18),
  },
  sectionHeading: {
    fontSize: dynamicFontSize(14),
    fontFamily: "Sen-Bold",
    color: Colours.DARKLIGHTGRAY,
    textTransform: "uppercase",
    letterSpacing: 1,
    marginBottom: dynamicSpacing(12),
    marginLeft: dynamicSpacing(4),
  },
  menuWrapper: {
    gap: dynamicSpacing(12), // Smooth spacing gaps between option items
  },
  // Modern Layout Action Rows
  profileDataContainer: {
    backgroundColor: "white",
    padding: dynamicSpacing(14),
    borderRadius: dynamicSize(12),
    elevation: 1,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.04,
    shadowRadius: 2,
  },
  disabledContainer: {
    opacity: 0.5,
  },
  profileDataSubContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  iconCircleWrapper: {
    width: dynamicSize(40),
    height: dynamicSize(40),
    borderRadius: dynamicSize(10),
    backgroundColor: Colours.PRIMARY_LIGHTER, // Light background tint matching brand primary color
    alignItems: "center",
    justifyContent: "center",
  },
  flatArrowContainer: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginLeft: dynamicSpacing(14),
  },
  textTxt: {
    color: Colours.DARKGRAY,
    fontSize: dynamicFontSize(15),
    fontFamily: "Sen-Medium",
  },
});
